import { render, staticRenderFns } from "./Subnavbar-ecom.vue?vue&type=template&id=3b950ae8&scoped=true"
import script from "./Subnavbar-ecom.vue?vue&type=script&lang=js"
export * from "./Subnavbar-ecom.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-ecom.vue?vue&type=style&index=0&id=3b950ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b950ae8",
  null
  
)

export default component.exports